import { render } from "./VamoosButton.vue?vue&type=template&id=7366fc93"
import script from "./VamoosButton.vue?vue&type=script&lang=js"
export * from "./VamoosButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__